import React from 'react';
//, {useState, useEffect}
import { Route, Routes } from "react-router-dom";
import { Container } from 'react-bootstrap';

import AppSummary from './app/AppSummary';
import AppPrompts from './app/Prompts';
import AppPromptFlow from './app/PromptFlow';
import AppResponseFlow from './app/ResponseFlow';
import AppResponses from './app/Responses';
import AppTranscripts from './app/Transcripts';
import AppTranscript from './app/Transcript';
import AppInteractions from './app/Interactions';
import AppInteraction from './app/Interaction';
import AppModels from './app/Models';
import AppModelDetails from './app/ModelDetails';
import AppPromptClusters from './app/PromptClusters';
import AppResponseClusters from './app/ResponseClusters';
import AppPromptClusterDetail from './app/PromptClusterDetail';
import AppResponseClusterDetail from './app/ResponseClusterDetail';
import AppPromptDetail from './app/PromptDetail';
import AppResponseDetail from './app/ResponseDetail';

import AppPromptClustersLive from './app/PromptClustersLive';
import AppPromptClusterDetailLive from './app/PromptClusterDetailLive';
import AppResponseClustersLive from './app/ResponseClustersLive';
import AppResponseClusterDetailLive from './app/ResponseClusterDetailLive';

import Guardrails from './app/Guardrails';

//import ChatSummary from './ChatSummary';
//import Dashboard from './Dashboard';
import Selection from './Selection';
import NotFound from '../../components/NotFound';

const Analytics = () => {
    //console.log('Apps: ' + (new Date()).toLocaleTimeString())
    //can add exact={true} to / as well
    return (
        <Container fluid>
            <Routes>
                {/*<Route path="/chatapp/:appKey/:startFactDate?/:endFactDate?" element={<ChatSummary />} />*/}
                <Route path="/app/:appKey/:startFactDate?/:endFactDate?" element={<AppSummary />} />
                <Route path="/app/:appKey/prompts/:startFactDate?/:endFactDate?" element={<AppPrompts />} />
                <Route path="/app/:appKey/promptflow/:promptId/:startFactDate?/:endFactDate?" element={<AppPromptFlow />} />
                <Route path="/app/:appKey/responseflow/:responseId/:startFactDate?/:endFactDate?" element={<AppResponseFlow />} />
                <Route path="/app/:appKey/responses/:startFactDate?/:endFactDate?" element={<AppResponses />} />
                <Route path="/app/:appKey/transcripts/:startFactDate?/:endFactDate?" element={<AppTranscripts />} />
                <Route path="/app/:appKey/transcript/:transcriptId/:startFactDate?/:endFactDate?" element={<AppTranscript />} />
                <Route path="/app/:appKey/interactions/:startFactDate?/:endFactDate?" element={<AppInteractions />} />
                <Route path="/app/:appKey/interaction/:interactionId/:startFactDate?/:endFactDate?" element={<AppInteraction />} />
                <Route path="/app/:appKey/summary/:startFactDate?/:endFactDate?" element={<AppSummary />} />
                <Route path="/app/:appKey/models/:startFactDate?/:endFactDate?" element={<AppModels />} />
                <Route path="/app/:appKey/model/:modelId/:startFactDate?/:endFactDate?" element={<AppModelDetails />} />
                <Route path="/app/:appKey/prompt/:promptId/:startFactDate?/:endFactDate?" element={<AppPromptDetail />} />
                <Route path="/app/:appKey/response/:responseId/:startFactDate?/:endFactDate?" element={<AppResponseDetail />} />

{/* 
                <Route path="/app/:appKey/promptclusters/:startFactDate?/:endFactDate?" element={<AppPromptClusters />} />
                <Route path="/app/:appKey/promptcluster/:idx/:startFactDate?/:endFactDate?" element={<AppPromptClusterDetail />} />
                <Route path="/app/:appKey/responseclusters/:startFactDate?/:endFactDate?" element={<AppResponseClusters />} />
                <Route path="/app/:appKey/responsecluster/:idx/:startFactDate?/:endFactDate?" element={<AppResponseClusterDetail />} />
*/}
                <Route path="/app/:appKey/promptclusters/:startFactDate?/:endFactDate?" element={<AppPromptClustersLive />} />
                <Route path="/app/:appKey/promptcluster/:promptId/:startFactDate?/:endFactDate?" element={<AppPromptClusterDetailLive />} />
                <Route path="/app/:appKey/responseclusters/:startFactDate?/:endFactDate?" element={<AppResponseClustersLive />} />
                <Route path="/app/:appKey/responsecluster/:responseId/:startFactDate?/:endFactDate?" element={<AppResponseClusterDetailLive />} />
                <Route path="/app/:appKey/guardrails/:startFactDate?/:endFactDate?" element={<Guardrails />} />
                {/*<Route path="/dashboard/:startFactDate?/:endFactDate?" element={<Dashboard />} />*/}
                <Route path="/" element={<Selection />} />
                {/*<Route path="/:startFactDate?/:endFactDate?" element={<Dashboard />} exact={true} />*/}
                <Route path="*" element={<NotFound />} />
            </Routes>

        </Container>
    )
}

export default Analytics;
